<template>
  <div class="Appointment">
    <div class="top">
      <p>
        <span>患者姓名:</span>
        <Input v-model="searchName" placeholder="患者姓名/手机号码" style="width:200px"/>
      </p>
      <p>
        <span>医生姓名:</span>
        <Input v-model="doctorName" placeholder="医生姓名" style="width:200px"/>
      </p>
      <p>
        <span>自定义日期：</span>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="startTime" placeholder="开始日期" v-model="startDate"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="endTime" placeholder="结束日期" v-model="endDate"></DatePicker>
      </p>
      <Button type="primary" custom-icon="iconfont icon-sousuo1" class="basicBtn" @click="search" @keyup.enter.native="search()" >搜索</Button>
      <Button type="primary" custom-icon="iconfont icon-jia" class="basicBtn" @click="newCase">新建</Button>
      
      <!-- <Button type="primary" custom-icon="iconfont icon-daoru" class="basicBtn">导入</Button>
      <Button type="primary" custom-icon="iconfont icon-xiazai" class="basicBtn">下载模板</Button> -->
    </div>
    <div class="main">
      <div class="leftBox">
        <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1" ></Table>
        <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize"/>
        </div>
      </div>
    </div>
    <Modal 
      class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="delBtn"
        @on-cancel="cancelBtn"
        ok-text="是" cancel-text="否">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
  </div>
</template>

<script>
import {
  caseList,delCase
} from "../../api/casemanage";
import {
  patientSource
} from "../../api/clinic";
import { tips,replaceT,payType,formatDate,payState,settleState } from "../../tools";
export default {
  name: 'CaseManage',
  inject: ['reload'],
  data () {
    return {
      //禁用今天之后的日期
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      tableHeight:632,
      delId:0,//删除id
      total:0,
      startDate:'',//开始日期
      endDate:'',//结束日期
      pageCurrent:1,
      pageSize: 10,
      searchName:'',//患者姓名/手机号
      doctorName:'',//医生姓名
      modelName:'',
      modelTitle:'',
      modal1:false,
      iconColor:'',
      modeIcon:'',
      modelContent:'',
      columns1:[
         {
           width:120,
          title: '病历号',
          key: 'caseNo',
          align:'center',
        },
        {
          title: '患者名字',
          key: 'hospitalPatientName',
          align:'center',
        },
        {
          title: '医生名字',
          key: 'doctorName',
          align:'center',
        },
        {
          title:'就诊时间',
          key:'diagnosisTime',
          align:'center',
           render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.diagnosisTime) 
              },
            })
          }
        },
        {
          width:120,
          title: '主诉',
          key: 'performance',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              },
              domProps: {
                title:params.row.performance,
                innerHTML: params.row.performance
              },
            })
          }
        },
        {
          title: '诊断',
          key: 'diagnosis',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              },
              domProps: {
                title:params.row.diagnosis,
                innerHTML: params.row.diagnosis
              },
            })
          }
        },
        {
          title: '医嘱',
          key: 'medicalOrder',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              },
              domProps: {
                title:params.row.medicalOrder,
                innerHTML: params.row.medicalOrder
              },
            })
          }
        },
        {
          title: '状态',
          key: 'state',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: payState(params.row.state)?payState(params.row.state):'' 
              },
            })
          }
        },
        {
          title: '结算状态',
          key: 'settlementState',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: settleState(params.row.settlementState) 
              },
            })
          }
        },
        {
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:100,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.$router.push({path:'cliniclist',query:{hospitalCaseId:params.row.id}});
                      this.$store.state.sickName = 3;
                    },
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.delId = id;
                      this.modal1 = true;
                      this.modelName = 'delCase';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否删除病历?';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                    }
                  }
                }, '删除'),
            ]);
          }
        }
      ],
      data1:[
      ],
      patientName:'',
      phone:'',
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      if(this.$refs){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
      }
    },
    //加载页面数据
    loadList(){
      this.search();
    },
    //查询预约挂号
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        nameAndPhone: _this.searchName,
        name: _this.doctorName,
        size: _this.pageSize,
        starTimes: _this.startDate,
        endTimes:_this.endDate
      };
      caseList(
        params
      ).then(res => {
        console.log(res);
        let data = res.records;
        _this.data1 = data;
        _this.total = res.total;
      })
    },
    //删除病历
    delCase(id){
      delCase({
        id:id
      }).then(res=>{
        console.log(res);
        tips(this,res,'info');
        this.reload();
      });
    },
    newCase(){
      this.$router.push({path:'cliniclist'});
    },
    //删除确定按钮
    delBtn(){
      this.delCase(this.delId);
    },
    //删除取消按钮
    cancelBtn(){
      this.modal1 = false;
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
     startTime(e){
      this.startDate = e;
      console.log(e)
    },
    endTime(e){
      this.endDate = e;
      console.log(e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.Appointment{
  border: 1px solid #c9c9c9;
  overflow: scroll;
  height: 100%;
}
.top{
  padding: 19px;
  border-bottom: 1px solid #c9c9c9;
  display: flex;
  justify-content:baseline;
  flex-flow: wrap row;
}
.top>p:not(:last-child){
  display: flex;
  justify-content: space-between;
  flex-flow: wrap row;
  margin-bottom: 10px;
}
.top>p>span{
  display: inline-block;
  height: 36px;
  line-height: 36px;
  color: #030303;
  font-size: 16px;
  margin-right: 5px;
}
.top>p{
  margin-right: 20px;
  line-height: 36px;
}
.top>p>.ivu-date-picker{
  margin-right: 5px;
}
.top>p>.ivu-date-picker:last-child{
  margin-left: 5px;
}
.top>p>.ivu-input-wrapper{
  height: 36px;
}
.top>p /deep/ .ivu-select-selection{
  height: 36px;
}
.top>p /deep/ input{
  height: 36px;
}
.top>.ivu-btn{
  margin-right:10px;
}
.main{
  padding: 18px 20px 20px 22px;
  /* height: 28px; */
}
.main{
  /* padding: 18px 53px 0 52px; */
  display: flex;
  justify-content: space-around;
}
.leftBox{
  width: 100%;
  display: inline-block;
}
   
/* rili */
.ivu-icon{
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ivu-icon-ios-calendar-outline:before {
    content: "\e622";
}
.basicBtn{
  height: 36px;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ageBox>li>div{
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
.ivu-date-picker{
  width: 120px;
}
.infoModal /deep/ .ivu-modal-content{
  height: auto ;
}
</style>



// WEBPACK FOOTER //
// src/views/casemanage/CaseManage.vue